import React, { useState, useEffect } from 'react'
import { Card, Form } from 'react-bootstrap'
import UploadButton from '../components/UploadButton';
import SliderNormal from '../../../../ui/Slider/SliderNormal';
import MiniImageList from '../components/MiniImageList';

const PlayerEvaluationCard = ({
    title,
    metricKey,
    insertedImage
}) => {
    const [imageList, setImageList] = useState([]);

    const updateImageList = (img) => {
        if(img) setImageList(prevList => [ ...prevList, img ])
    }

    useEffect(() => {
        updateImageList(insertedImage);
    }, [insertedImage])

    return (
        <Card className="player-evaluation-card">
            <Card.Header>
                <Card.Title>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="slider-container">
                    <SliderNormal min={0} max={100} showMarks />
                </div>
                <Form.Group controlId="attacking-note">
                    <Form.Control
                        as="textarea"
                        name="attackingNote"
                        rows="3"
                        className="custom-textarea"
                        placeholder="Writes your notes if any"
                    />
                </Form.Group>
                <div className="add-btn-container">
                    <MiniImageList images={imageList}>
                        <UploadButton
                            variant="secondary"
                            showLabel={!imageList.length}
                            label="Attach Images and Videos"
                            inputId={metricKey}
                            onUpload={updateImageList}
                        />
                    </MiniImageList>
                </div>
            </Card.Body>
        </Card>
    )
}

export default PlayerEvaluationCard
